import { render, staticRenderFns } from "./BookingNavigation.vue?vue&type=template&id=a1361356&scoped=true&"
import script from "./BookingNavigation.vue?vue&type=script&lang=ts&"
export * from "./BookingNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./BookingNavigation.vue?vue&type=style&index=0&id=a1361356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1361356",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFooter,VRow})
